import React from 'react';
import { useSelector } from 'react-redux';
import { getAuthorAvatarsFromPublication } from '../utils/matchAuthorAvatarsByFilterD';

export const useAuthorAvatarsFromPublication = (publication) => {
  const authorCards = useSelector((state) => state.author_cards?.cards ?? []);

  return React.useMemo(
    () => getAuthorAvatarsFromPublication(publication, authorCards),
    [publication, authorCards],
  );
};
